export var MULTI_SELECT_MARK_PROPNAME = 'checkboxSelection';
export var SINGLE_SELECT_MARK_PROPNAME = 'radioSelection';
export function isSelectColumn(column) {
  var features = column.features || {};
  return features[MULTI_SELECT_MARK_PROPNAME] === true || features[SINGLE_SELECT_MARK_PROPNAME] === true;
}